// Short looping clips the user downloaded for specific games, keyed per rail
// since Hot and Recommended each ship their own clip set (some game names —
// Aviatrix, Fortune Gems 500 — appear in both with a different clip).
// Keyed by the game name with everything but letters/digits stripped,
// lowercased, so "Crazy Time" and "crazy-time" line up the same way.
const normalize = (value: string) => value.toLowerCase().replace(/[^a-z0-9]/g, '');

export const HOT_PREVIEW_VIDEOS: Record<string, string> = {
  andarbahar: '/videos/casino-previews/hot/andar-bahar.mp4',
  aviatrix: '/videos/casino-previews/hot/aviatrix.mp4',
  colorgame: '/videos/casino-previews/hot/color-game.mp4',
  crazy777: '/videos/casino-previews/hot/crazy-777.mp4',
  fortunegems500: '/videos/casino-previews/hot/fortune-gems-500.mp4',
  funkytime: '/videos/casino-previews/hot/funky-time.mp4',
  mines: '/videos/casino-previews/hot/mines.mp4',
  plinko: '/videos/casino-previews/hot/plinko.mp4',
  sweetbonanza: '/videos/casino-previews/hot/sweet-bonanza.mp4',
  teenpatti2020: '/videos/casino-previews/hot/teen-patti-20-20.mp4',
  // The supplied icons for these were 3MB animated GIFs; re-encoded as ~60KB clips.
  fortunegems3: '/videos/casino-previews/hot/fortune-gems-3.mp4',
  superace: '/videos/casino-previews/hot/super-ace.mp4',
  moneycoming: '/videos/casino-previews/hot/money-coming.mp4',
  wildbountyshowdown: '/videos/casino-previews/hot/wild-bounty-showdown.mp4',
};

export const RECOMMENDED_PREVIEW_VIDEOS: Record<string, string> = {
  cardmatka: '/videos/casino-previews/recommended/card-matka.mp4',
  cointoss: '/videos/casino-previews/recommended/coin-toss.mp4',
  crazytime: '/videos/casino-previews/recommended/crazy-time.mp4',
  dragontiger: '/videos/casino-previews/recommended/dragon-tiger.mp4',
  fortunegems500: '/videos/casino-previews/recommended/fortune-gems-500.mp4',
  sicbo: '/videos/casino-previews/recommended/sic-bo.mp4',
  speedbaccarat: '/videos/casino-previews/recommended/speed-baccarat.mp4',
  superace: '/videos/casino-previews/recommended/super-ace.mp4',
  goldenempire: '/videos/casino-previews/recommended/golden-empire.mp4',
};

export function getPreviewVideo(
  gameName: string,
  videos: Record<string, string> | undefined
): string | undefined {
  if (!videos) return undefined;
  return videos[normalize(gameName)];
}

// Negative ids mark synthetic (not-in-catalog) cards — see homeGameOrder.ts.
export const isPreviewOnlyGame = (id: number) => id < 0;
